import React from 'react';
import { getCampaignStatus } from '../../../utils';

const badges = {
  expired: {
    label: 'Expired',
    className: 'builder-bg-red-100 builder-text-red-700',
    title: 'The campaign has ended, this advertisement is no longer shown'
  },
  upcoming: {
    label: 'Upcoming',
    className: 'builder-bg-yellow-100 builder-text-yellow-800',
    title: 'The campaign has not started yet, this advertisement is not shown yet'
  }
};

const CampaignStatusBadge = ({ campaign, className = '' }) => {
  const badge = badges[getCampaignStatus(campaign)];
  if (!badge) return null;

  return (
    <span className={`builder-px-2 builder-rounded-full builder-text-sm builder-font-semibold ${badge.className} ${className}`} title={badge.title}>
      {badge.label}
    </span>
  );
};

export default CampaignStatusBadge;
